webpackJsonp([78],{

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.action.processing)?[_c('loader',{attrs:{"content":'Please wait',"visible":_vm.action.processing}})]:[_c('div',{staticClass:"container",staticStyle:{"padding-top":"25px"}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[(_vm.action.succeed)?[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-center mb-20"},[_vm._v("\n              You may close this window at any time.\n            ")])]:[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text-center mb-20"},[_vm._v("\n              "+_vm._s(_vm.action.message)+"\n            ")])]],2)])])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"--green"},[_c('b',[_vm._v("Success !")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"sts-danger"},[_c('b',[_vm._v("Oops!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__ = __webpack_require__(821);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332dc6fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__ = __webpack_require__(1113);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332dc6fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reservationId: null,
      amendmentId: null,
      state: null,
      mail: null,
      action: {
        processing: true,
        succeed: false,
        message: "Something went wrong, please try again later."
      }
    };
  },
  created: function created() {
    this.constructParams();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var self, url, config;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              FreshworksWidget("hide");
              self = _this;
              url = "https://prod-gateway-opsicar.idteknologia.net" + "/api/shop/reservations/" + _this.reservationId + "/amend/" + _this.amendmentId + "/respond";
              config = {
                headers: { _pub: "true" }
              };
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + ("?state=" + _this.state + "&mail=" + _this.mail), config).then(function (response) {
                if (response.data.isSuccess) {
                  self.action.processing = false;
                  self.action.succeed = true;
                } else {
                  self.action.processing = false;
                  self.action.succeed = false;
                  self.action.message = response.data.errors[0];
                }
              }).catch(function (error) {
                self.handleError(error);
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    constructParams: function constructParams() {
      if (this.$route.query.state && this.$route.query.mail) {
        this.reservationId = this.$route.params.reservation_id;
        this.amendmentId = this.$route.params.amendment_id;
        this.state = this.$route.query.state;
        this.mail = this.$route.query.mail;

        this.state = parseInt(this.state);

        if (this.state === NaN) {
          this.$router.push({ path: "/404" });
        }
      } else {
        this.$router.push({ path: "/404" });
      }
    },
    handleError: function handleError(error) {
      this.action.processing = false;
      this.action.succeed = false;

      if (error.response) {
        if (error.response.data.errors) {
          if (Array.isArray(error.response.data.errors)) {
            this.action.message = error.response.data.errors[0];
          } else {
            for (var prop in error.response.data.errors) {
              if (!error.response.data.errors.hasOwnProperty(prop)) {
                continue;
              }
              this.action.message = error.response.data.errors[prop][0];
              break;
            }
          }
        } else {
          this.action.message = "Request failed with status code " + error.response.status;
        }
      } else if (error.request) {
        this.action.message = "Something wrong with request messages.";
      } else {
        this.action.message = "Something went wrong, please try again later.";
      }
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/78.c294577bb47e7e2297a4.js